export class Constant {
  public static AddendumTemplateName: string = "AddendumTemplate.docx";
  public static GlobalNotificationGroupName: string = "GlobalNotificationGroup";

  public static UserId: number;
  public static PageSizes = [
    { name: "Show 10 Items", value: 10 },
    { name: "Show 15 Items", value: 15 },
    { name: "Show 20 Items", value: 20 },
    { name: "Show 25 Items", value: 25 },
    { name: "Show 50 Items", value: 50 },
    { name: "Show 100 Items", value: 100 },
  ];
}

export enum UserRoleUserOperation {
  ShowLocation = 1,
  CanAddNewGrs = 2,
  CanEditGrs = 3,
  ShowAddNewEquipment = 4,
  ViewAllGrsStandard = 5,

  //Nrbes
  ShowAddNewNrbes = 6,
  CanAddNewNrbes = 7,
  CanUpdateNrbes = 8,
  ViewAllNrbesStandard = 9,

  //Notification
  ViewAllNotification = 10,

  //BuildingCapacityTool
  ShowBuildingCapacityTool = 11,

  //Faq
  ViewFaq = 12,
  CanAddFaq = 13,
  CanEditFaq = 14,
  CanDeleteFaq = 15,

  //KeyContacts
  ViewKeyContacts = 16,
  CanAddKeyContacts = 17,
  CanEditKeyContacts = 18,
  CanDeleteKeyContacts = 19,

  //Addendum
  ViewAllAddendum = 20,
  CanAddAddendum = 21,
  CanUpdateAddendum = 22,
  ViewFutureStandard = 23,

  //Equipment Standard
  CanAddEquipmentStandard = 24,
  CanEditEquipmentStandard = 25,
  CanDeleteEquipmentStandard = 26,
  ViewEquipmentGlobalStandard = 27,
  ViewEquipmentNationalStandard = 28,
  ViewEquipmentObsoleteStandard = 29,
  CanAddNationalEquipmentStandard = 30,
  ViewUpcomingStandard = 31,
  CanEditNationalEquipmentStandard = 32,
  CanDeleteNationalEquipmentStandard = 33,
  CanRemoveEquipmentStandard = 34,
  ViewGlobalAdminPanel = 35,
  ViewMarketAdminPanel = 36,
  ViewManageSuppliers = 37,
  ViewAllSuppliers = 38,
  CanAddSupplier = 39,
  CanEditSupplier = 40,
  CanDeleteSupplier = 41,
  ViewAllEquipmentType = 42,
  CanAddEquipmentType = 43,
  CanEditEquipmentType = 44,
  ViewAllCategory = 45,
  CanAddCategory = 46,
  CanEditCategory = 47,
  CanDeleteCategory = 48,
  ViewAllUser = 49,
  CanAddUser = 50,
  CanEditUser = 51,
  CanDeleteUser = 52,
  ViewUserDetail = 53,
  ViewSupplierDetail = 54,
  ViewAllNationalSuppliers = 55,
  CanAddNationalSupplier = 56,
  CanEditNationalSupplier = 57,
  ViewNationalSupplierDetail = 58,
  CanDeleteNationalSupplier = 59,
  CanDeleteEquipmentType = 60,
  ViewAllSharedLearningsBestPractices = 61,
  CanAddABUStandard = 62,
  CanEditABUStandard = 63,
  CanDeleteABUStandard = 64,
  ViewABUStandard = 65,
  CanAddOperationsStandard = 66,
  CanEditOperationsStandard = 67,
  CanDeleteOperationsStandard = 68,
  ViewOperationsStandard = 69,
  ViewAllUsefulLinks = 70,
  CanAddUsefulLink = 71,
  CanEditUsefulLink = 72,
  CanDeleteUsefulLink = 73,
  ViewUsefulLinkDetail = 74,
  CanUpdateApplicationStatement = 75,
  canViewAsDifferentRole = 76
}

export enum AddendumStatusEnum {
  Requested = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4,
  DraftAfterRequest = 5,
  DraftBeforeRequest = 6,
}

export enum StandardType {
  GlobalRecommendations = 1,
  MarketBestPractices = 2,
  LocalStandard = 3,
  GlobalMinimumRestaurantStandard = 4,
  EquipmentStandard = 5,
  OperationsStandard = 6,
}

export enum UserRoleEnum {
  GlobalAdmin = 1,
  MarketAdmin = 2,
  BasicUser = 3,
  AOWAdmin = 4,
}

export enum UserRole {
  GlobalAdmin = 1,
  MarketAdmin = 2,
  BasicUser = 3,
}

export enum FilteringEnum {
  FilterByLocationType = 1,
  FilterByCategory = 2,
  FilterByStandardType = 3,
  FilterByEquipmentType = 4,
  FilterBySubLocationType = 5,
}

export enum StandardTypeEnum {
  GlobalRecommendations = 1,
  MarketBestPractices = 2,
  LocalStandard = 3,
  GlobalMinimumRestaurantStandard = 4,
  GlobalEquipmentStandard = 5,
  LocalEquipmentStandard = 6,
  ABUStandard = 7,
  OperationsStandards = 8,
}

export enum RygStandardEnum {
  Red = 1,
  Yellow = 2,
  Green = 3,
}

export enum CategoryEnum {
  BuildingAndSite = 1,
  OperatingPlatforms = 2,
  PeopleAndTraining = 3,
  SafetyAndSecurity = 4,
  Sustainability = 5,
  Technology = 6,
  FoodSafety = 7,
  Equipment = 8,
  GlobalDevelopment = 9,
  Operations = 10,
}

export enum EquipmentClassEnum {
  Core = 1,
  Local = 2,
}

export enum LocationTypeEnum {
  ParkingLot = 1,
  DriveThru = 2,
  ManagerSpace = 3,
  CrewSpace = 4,
  BackRoom = 5,
  RestRooms = 6,
  Storage = 7,
  Kitchen = 8,
  Lobby = 9,
  FrontCounter = 10,
  PlayPlace = 11,
  BuildingExterior = 12,
  EntireBuilding = 13,
  Beverage = 14,
  McCafe = 15,
  Delivery = 16,
  Curbside = 17,
}

export enum StandardListType {
  Obsolete = 1,
  Minimum = 2,
  Upcoming = 3,
  GlobalEquipment = 4,
  NationalEquipment = 5,
  National = 6,
  Location = 7,
  DependentStandard = 8,
  GlobalRecomendation = 9,
  SharedLearningsAndRecomendations = 10,
  OperationsStandard = 11,
  AllStandards = 12,
}

export enum MasterDataRequestedType {
  AddGlobalStandard = 1,
  AddNationalStandard = 2,
  AddNationalEquipmentStandard = 3,
  AddGlobalEquipmentStandard = 4,
}

export enum AllStandardsTabs {
  GlobalRecommendations = 1,
  OperationsStandard = 2,
  BuildingStandards = 3,
  EquipmentStandards = 4,
  AllStandards = 5,
  MarketStandards = 6,
}

export enum countryISO{
  CAN= 1,
ARG= 2,
AUS= 3,
BRA= 4,
CHN= 5,
GBR= 6,
FRA= 7,
DEU= 8,
HKG= 9,
IND= 10,
ITA= 11,
JPN= 12,
MYS= 14,
MEX= 15,
NLD= 16,
NZL= 19,
POL= 21,
PRI= 22,
SGP= 24,
ESP= 25,
SWE= 26,
CHE= 27,
TWN= 28,
US= 29,
ABW= 30,
AUT= 31,
AZE= 32,
BHS= 33,
BHR= 34,
BEL= 36,
BIH= 37,
BRN= 38,
BGR= 39,
CHL= 40,
COL= 41,
CRI= 42,
HRV= 43,
CUW= 44,
CYP= 45,
CZE= 46,
DNK= 47,
DOM= 48,
ECU= 49,
EGY= 50,
SLV= 51,
EST= 52,
FIN= 53,
GUF= 54,
GEO= 55,
GRC= 56,
GLP= 57,
GTM= 58,
HND= 59,
HUN= 60,
IDN= 61,
ISR= 63,
JOR= 64,
KAZ= 65,
KWT= 66,
LVA= 67,
LBN= 68,
LTU= 69,
MLT= 72,
MTQ= 73,
MUS= 74,
MDA= 75,
MAR= 76,
NIC= 77,
NOR= 78,
OMN= 79,
PAK= 80,
PAN= 81,
PRY= 82,
PER= 83,
PHL= 84,
PRT= 85,
QAT= 86,
REU= 87,
ROU= 88,
SAU= 89,
SCG= 91,
SVK= 92,
SVN= 93,
ZAF= 94,
KOR= 95,
SXM= 97,
SUR= 98,
THA= 99,
TTO= 100,
TUR= 101,
UKR= 102,
ARE= 103,
URY= 105,
VEN= 106,
VNM= 107,
VIR= 108,
INM= 112,
}

export enum notificationGroup {
  CANNotificationGroup=1,
ARGNotificationGroup=2,
AUSNotificationGroup=3,
BRANotificationGroup=4,
CHNNotificationGroup=5,
GBRNotificationGroup=6,
FRANotificationGroup=7,
DEUNotificationGroup=8,
HKGNotificationGroup=9,
INDNotificationGroup=10,
ITANotificationGroup=11,
JPNNotificationGroup=12,
MYSNotificationGroup=14,
MEXNotificationGroup=15,
NLDNotificationGroup=16,
NZLNotificationGroup=19,
POLNotificationGroup=21,
PRINotificationGroup=22,
SGPNotificationGroup=24,
ESPNotificationGroup=25,
SWENotificationGroup=26,
CHENotificationGroup=27,
TWNNotificationGroup=28,
USNotificationGroup=29,
ABWNotificationGroup=30,
AUTNotificationGroup=31,
AZENotificationGroup=32,
BHSNotificationGroup=33,
BHRNotificationGroup=34,
BELNotificationGroup=36,
BIHNotificationGroup=37,
BRNNotificationGroup=38,
BGRNotificationGroup=39,
CHLNotificationGroup=40,
COLNotificationGroup=41,
CRINotificationGroup=42,
HRVNotificationGroup=43,
CUWNotificationGroup=44,
CYPNotificationGroup=45,
CZENotificationGroup=46,
DNKNotificationGroup=47,
DOMNotificationGroup=48,
ECUNotificationGroup=49,
EGYNotificationGroup=50,
SLVNotificationGroup=51,
ESTNotificationGroup=52,
FINNotificationGroup=53,
GUFNotificationGroup=54,
GEONotificationGroup=55,
GRCNotificationGroup=56,
GLPNotificationGroup=57,
GTMNotificationGroup=58,
HNDNotificationGroup=59,
HUNNotificationGroup=60,
IDNNotificationGroup=61,
ISRNotificationGroup=63,
JORNotificationGroup=64,
KAZNotificationGroup=65,
KWTNotificationGroup=66,
LVANotificationGroup=67,
LBNNotificationGroup=68,
LTUNotificationGroup=69,
MLTNotificationGroup=72,
MTQNotificationGroup=73,
MUSNotificationGroup=74,
MDANotificationGroup=75,
MARNotificationGroup=76,
NICNotificationGroup=77,
NORNotificationGroup=78,
OMNNotificationGroup=79,
PAKNotificationGroup=80,
PANNotificationGroup=81,
PRYNotificationGroup=82,
PERNotificationGroup=83,
PHLNotificationGroup=84,
PRTNotificationGroup=85,
QATNotificationGroup=86,
REUNotificationGroup=87,
ROUNotificationGroup=88,
SAUNotificationGroup=89,
NotificationGroup=90,
SCGNotificationGroup=91,
SVKNotificationGroup=92,
SVNNotificationGroup=93,
ZAFNotificationGroup=94,
KORNotificationGroup=95,
SXMNotificationGroup=97,
SURNotificationGroup=98,
THANotificationGroup=99,
TTONotificationGroup=100,
TURNotificationGroup=101,
UKRNotificationGroup=102,
ARENotificationGroup=103,
URYNotificationGroup=105,
VENNotificationGroup=106,
VNMNotificationGroup=107,
VIRNotificationGroup=108,
}



export const basicRoleOPerations: Array<number> = [
    1, 5, 9, 12, 16, 20, 23, 27, 28, 29, 31, 61, 65, 69,
  ];

  export const marketRoleOPerations: Array<number> = [
    1, 5, 6, 7, 8, 9, 10, 11, 12, 16, 20, 21, 23, 27, 28, 29, 30, 31, 32, 33,
    34, 36, 37, 55, 56, 57, 58, 59, 61, 65, 69,
  ];

  export const aowRoleOperations: Array<number> = [
    1, 5, 6, 7, 8, 9, 10, 11, 12, 16, 20, 21, 23, 27, 28, 29, 30, 31, 32, 33,
    34, 36, 37, 55, 56, 57, 58, 59, 61, 62, 63, 64, 65, 69,
  ];